var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"link":"","to":_vm.item.pgmId,"active-class":"secondary"}},[_c('v-list-item-icon'),_c('v-list-item-title',{staticClass:"nav_title--text"},[_vm._v(" "+_vm._s(_vm.item.ename)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }